import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { default as React, useEffect, type FC } from 'react';

import logoutImage from './logout.jpg';

export const LogoutPage: FC = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      void instance.logoutRedirect();
    }
  }, [isAuthenticated, instance]);

  return (
    <>
      <img src={logoutImage} alt="You've just successfully logged out" />
    </>
  );
};
